import React, { Component } from 'react';
import Signup from 'components/Signup';
import Banner from 'components/Banner';
import Details from 'components/Details';
import { withRouter } from 'react-router';
import { logPageView, initGA } from 'utils/analytics';
import { connect } from 'react-redux'; // to connect to redux store from containers redux.js or any other redux store
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import Session from 'components/SessionReplica';
import { registerSelector } from 'containers/Register/Register.redux';
import registerUser from 'containers/Register/Register.actions';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import styles from './Register.scss';// to import local scss fle


class Register extends Component {
  static propTypes = {
    isValid: PropTypes.bool.isRequired,
    history: PropTypes.shape(),
  };
  static defaultProps = {
    history: {},
  };
  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
  }

  componentWillMount() {
    if (this.props.isValid) {
      this.props.history.push('/');
    }
  }
  componentDidMount() {
    initGA();
        logPageView(this.props.match.path); // eslint-disable-line
  }

  render() {
    const joinUsData = {
      bannerHeader: 'JOIN THE GREATEST',
      bannerDesc: "We're proud to make recruiting simpler, faster and more personal with greater exposure.",
      detailsHeader: 'Join MyRecruitBoard',
      detailsDesc: '',
      otherPages: true,
      page: 'register',
    };
    return (
      <div className={cn('row', styles.joinUsContainer)}>
        <div className={cn('col s6', styles.joinUsBanner)}>
          <Banner data={joinUsData} usedFor="register" />
        </div>
        <div className={cn('col s12 m6', styles.joinUsDetails)}>
          <Details data={joinUsData} {...this.props}>
            <Signup {...this.props} />
          </Details>
        </div>
      </div>
    );
  }
}

export default connect(registerSelector, {
  registerUser,
})(withRouter(Session(Register)));



// WEBPACK FOOTER //
// ./src/containers/Register/Register.js